module.exports = __webpack_public_path__ + "img/app/home/img/icon-arrow-lf-hover.3adf992aef554b9859c86d0f2b4c16b7.png";